var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.55556 12.4444H2.66389L10.2667 4.84167L9.15833 3.73333L1.55556 11.3361V12.4444ZM0 14V10.6944L10.2667 0.447222C10.4222 0.30463 10.594 0.194444 10.7819 0.116667C10.9699 0.0388889 11.1676 0 11.375 0C11.5824 0 11.7833 0.0388889 11.9778 0.116667C12.1722 0.194444 12.3407 0.311111 12.4833 0.466667L13.5528 1.55556C13.7083 1.69815 13.8218 1.86667 13.8931 2.06111C13.9644 2.25556 14 2.45 14 2.64444C14 2.85185 13.9644 3.04954 13.8931 3.2375C13.8218 3.42546 13.7083 3.59722 13.5528 3.75278L3.30556 14H0ZM9.70278 4.29722L9.15833 3.73333L10.2667 4.84167L9.70278 4.29722Z",
    fill: "#005BF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit_pencil.82b0e77369ca7ee5df61169871697144.svg";
export { ForwardRef as ReactComponent };